/*
Controller: Settings

Operations:
  getSettings
  updateSettings
*/
var Api = require('../config')
var SettingsDef = require('../definitions/Settings')

var Settings = (function () {
  /*
  Operation: getSettings
  Get all Foundry settings for the current user and session
  Parameters:
  Responses:
    HTTP 200: Settings object
  */
  function getSettingsSettings () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/settings'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateSettings
  Update Foundry settings for the current user and session
  Parameters:

  Responses:
    HTTP 200: Settings update successful
    HTTP 400: Settings update failed
  */
  function updateSettingsSettings (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        SettingsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/settings'
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getSettings'] = getSettingsSettings
  ret['updateSettings'] = updateSettingsSettings
  return ret
})()

module.exports = Settings
